export default "__VITE_ASSET__454d2051__"